(function(angular){
	'use strict';

	angular
		.module('fundriseInvestorsEarnMoreChartModule')
		.directive('fundriseInvestorsEarnMoreChart', [
			'$window',
			'BREAKPOINTS', 
			'HIGHCHARTS_OPTIONS',
			'planFactory',
			'STATIC_BASE_PATH',
			'TRADITIONAL_INVESTMENT_COMPS',
			FundriseInvestorsEarnMoreChartFunction
		]);

	function FundriseInvestorsEarnMoreChartFunction(
		$window,
		BREAKPOINTS,
		HIGHCHARTS_OPTIONS,
		planFactory,
		STATIC_BASE_PATH,
		TRADITIONAL_INVESTMENT_COMPS) {
		return {
			replace: true,
			restrict: 'E',
			scope: {
				periods: '=',
				planId: '@',
				principal: '=',
				includeCallout: '=?'
			},
			templateUrl: STATIC_BASE_PATH + '/static/html/shared/charts/fundrise-investors-earn-more/fundrise-investors-earn-more-chart.html',
			link: function($scope, $attrs, $elem) {
				
				var chart;
				
				$scope.traditionalHypotheticalQuarterlyReturn = TRADITIONAL_INVESTMENT_COMPS.PUBLIC_EQUITY_HYPOTHETICAL_QUARTERLY_RETURN;
				
				Highcharts.setOptions(HIGHCHARTS_OPTIONS());

				planFactory.getQuarterlyReturn(['STANDARD'], $scope.planId).then(function(response){
					$scope.fundriseHypotheticalQuarterlyReturn = parseFloat(response);
					
					initChart();
				});
				
				var chartData = function(returnProfileHigh, returnProfileLow) {
					
					var data = [];
					
					for(var i = 0; i < $scope.periods + 1; i++) {

						var pointHigh = Math.pow(1 + returnProfileHigh, i) * $scope.principal;
						var pointLow = Math.pow(1 + returnProfileLow, i) * $scope.principal;						
						
						var point = {
							x: i,
							y: pointHigh,
							high: pointHigh,
							low: pointLow
						};
						
						data.push(point);
					}
					
					return data;	
				};
				
				function initChart(){
					chart = new Highcharts.Chart({
						chart: {
							renderTo: 'fundrise-investors-earn-more-chart'
						},
						plotOptions: {
							line: {
								marker: {
									enabled: false
								},
								states: {
									hover: {
										enabled: false
									}
								}
							}
						},
						series: [{
							type: 'line',
							color: {
								linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
								stops: [
									[0, '#F6A01A'],
									[1, '#F47735']
								]
							},
							data: chartData($scope.fundriseHypotheticalQuarterlyReturn, $scope.traditionalHypotheticalQuarterlyReturn)
						},{
							type: 'line',
							color: '#878C92',
							data: chartData($scope.traditionalHypotheticalQuarterlyReturn, 0)
						},{
							type: 'arearange',
							color: 'transparent',
							fillColor: {
								linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
								stops: [
									[0, Highcharts.Color('#FF6A19').setOpacity(0.5).get('rgba')],
									[1, Highcharts.Color('#F6A01A').setOpacity(0).get('rgba')]
								]
							},
							data: chartData($scope.fundriseHypotheticalQuarterlyReturn, $scope.traditionalHypotheticalQuarterlyReturn)
						},{
							type: 'arearange',
							color: 'transparent',
							fillColor: {
								linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
								stops: [
									[0, Highcharts.Color('#878C92').setOpacity(0.5).get('rgba')],
									[1, Highcharts.Color('#878C92').setOpacity(0).get('rgba')]
								]
							},
							data: chartData($scope.traditionalHypotheticalQuarterlyReturn, 0)
						}],
						xAxis: {
							allowDecimals: false,
							labels: {
								formatter: function() {
									var now = new Date();
									var currentYear = now.getFullYear();
									return currentYear + (this.value / 4);
								}
							},
							tickInterval: 20
						},
						yAxis: {
							endOnTick: false,
							labels: {
								formatter: function() {
									return '$' + Highcharts.numberFormat(this.value, 0);
								}
							},
							min: $scope.principal,
							startOnTick: false
						}
					}, function(chart) {

						var seriesLength = $scope.periods;

						var fundriseSegmentHeight = chart.series[1].data[$scope.periods].plotY - chart.series[0].data[$scope.periods].plotY;
						var fundriseSegmentTop = chart.series[0].data[$scope.periods].plotY + chart.plotTop;

						$scope.arrowStyle = {
							traditionalSegment: {
								top: chart.series[1].data[$scope.periods].plotY + chart.plotTop + 'px',
								height: chart.plotBox.height - chart.series[1].data[$scope.periods].plotY + 'px'
							},
							fundriseSegment: {
								top: fundriseSegmentTop + 'px',
								height: fundriseSegmentHeight + 'px'
							}
						};

						if($window.innerWidth >= BREAKPOINTS.MD_START) {

							$scope.seriesLabelPosition = {
								traditional: {
									position: 'absolute',
									left: '100%',
									top: $scope.arrowStyle.traditionalSegment.top,
									marginTop: '-0.75rem'
								},
								fundrise: {
									position: 'absolute',
									left: '100%',
									top: $scope.arrowStyle.fundriseSegment.top,
									marginTop: '-0.75rem'
								}
							};

							$scope.calloutPosition = {
								top: fundriseSegmentTop + (fundriseSegmentHeight / 2) + 'px',
								transform: 'translateY(-50%)'
							};
						}
					});
				}
			}
		};
	}
})(window.angular);